import { axiosApi } from "services/api";

// API call to get details of a single campaign
export const getSingleCampaignDetails = async (token, data) => {
    try {
      const response = await axiosApi.post("/campaign/get", data, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });
      return response;
    } catch (error) {
      throw error; // Throw error to be handled in the action
    }
  };